import { Dispatch, SetStateAction } from "react";
import {
    Modal,
    Button,
    TextField,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddVariant({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* HEADER */}
                    <div className="modal_title">
                        <h2>Add Variant</h2>
                        <IconButton
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                    </div>

                    {/* FORM */}
                    <div className="form">
                        <div className="control_group" >
                            <label htmlFor="variant-label">
                                Label
                            </label>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Label"
                                inputProps={{ id: "variant-label" }}
                            />
                        </div>

                        <div className="control_group" >
                            <label htmlFor="variant-value">
                                Value
                            </label>
                            <input id="variant-value" style={{ width: '100%' }} type="color" />
                        </div>

                        {/* FOOTER */}
                        <div className="footer_btn_flex" >
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                                style={{ height: '40px', padding: '0 30px', textTransform: 'none' }}
                            >
                                Submit
                            </Button>
                        </div>
                    </div>
                </div >
            </div >
        </Modal >
    );
}
